import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Calendar, User, ArrowRight, Users, GraduationCap, PartyPopper } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function BlogPage() {
  const posts = [{
    id: 1,
    title: "Forum Fondateur : L'ADCC à l'écoute des personnels de maison",
    excerpt: 'Retour sur notre tout premier événement qui a réuni une dizaine de personnels de maison de différents domaines. Une rencontre fondatrice qui a permis de cartographier les besoins réels et de poser les bases de notre action.',
    date: '10 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Événement',
    image: 'https://cdn.magicpatterns.com/uploads/exRoSvgKroC4rrK6KpbESt/WhatsApp_Image_2026-01-29_at_17.21.09.jpg',
    featured: true,
    content: `
        <p>L'Association Dignité Compétence Création (ADCC) a organisé son tout premier forum d'état des lieux, réunissant une dizaine de personnels de maison venus de différents horizons professionnels : entretien ménager, cuisine, garde d'enfants, gardiennage...</p>
        
        <h3>Une démarche d'écoute avant tout</h3>
        <p>Avant de lancer nos programmes de formation, nous avons voulu comprendre. Comprendre les réalités quotidiennes, les difficultés rencontrées, les aspirations de celles et ceux que nous souhaitons accompagner.</p>
        
        <h3>Ce que nous avons appris</h3>
        <ul>
          <li><strong>Un besoin criant de formation professionnelle</strong> : Beaucoup exercent sans avoir reçu de formation structurée, apprenant "sur le tas".</li>
          <li><strong>Une demande de reconnaissance</strong> : Les métiers de service à la personne souffrent d'un manque de considération sociale.</li>
          <li><strong>L'importance de l'accompagnement</strong> : Trouver un emploi est une chose, le garder dans de bonnes conditions en est une autre.</li>
        </ul>
        
        <h3>Les prochaines étapes</h3>
        <p>Ce forum a posé les fondations de notre approche : écouter d'abord, agir ensuite. Les enseignements tirés de cette rencontre guident aujourd'hui la conception de nos ateliers de formation prévus pour mars 2026.</p>
        
        <p>Merci à tous les participants qui ont accepté de partager leur vécu avec nous. Ensemble, nous construisons un avenir plus digne pour les personnels de maison au Bénin.</p>
      `
  }, {
    id: 2,
    title: 'Ateliers de Formation Mars 2026 : Inscriptions ouvertes !',
    excerpt: "L'ADCC lance sa première session intensive de formation aux métiers de l'entretien et de la maintenance. Au programme : panels métiers, pitch CV avec jury, techniques professionnelles et compétences relationnelles. Places limitées !",
    date: '10 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Formation',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    featured: false,
    content: `
        <p>C'est officiel : l'ADCC organise sa toute première session de formation intensive en mars 2026 ! Un moment historique pour notre jeune association, fruit de plusieurs mois de préparation et d'écoute des besoins du terrain.</p>
        
        <h3>Un programme complet et innovant</h3>
        <p>Nos ateliers ne se limitent pas à la théorie. Nous avons conçu un programme qui allie apprentissage technique et développement personnel :</p>
        <ul>
          <li><strong>Panels sur les métiers d'entretien et maintenance</strong> : Des professionnels expérimentés partagent leur parcours et leurs conseils.</li>
          <li><strong>Pitch CV avec jury</strong> : Apprenez à vous présenter et à valoriser vos compétences devant des recruteurs.</li>
          <li><strong>Introduction aux techniques d'entretien, maintenance et hygiène</strong> : Les fondamentaux du métier, avec des mises en situation pratiques.</li>
          <li><strong>Compétences relationnelles et communication</strong> : Savoir-être, gestion des situations délicates, communication professionnelle.</li>
        </ul>
        
        <h3>Nouveauté : Dispositif de placement intégré</h3>
        <p>Les participants aux ateliers de mars 2026 pourront intégrer, selon leur profil, le dispositif de placement ADCC. Notre objectif : que la formation débouche sur de vraies opportunités d'emploi.</p>
        
        <h3>Comment s'inscrire ?</h3>
        <p>Les places sont limitées pour garantir un accompagnement de qualité. Rendez-vous sur notre page "Nos Actions" pour remplir le formulaire d'inscription. Notre équipe examinera chaque candidature et vous recontactera.</p>
        
        <p><strong>Ensemble, transformons les compétences en opportunités !</strong></p>
      `
  }, {
    id: 3,
    title: 'Festival des Personnels de Maison - Juin 2026 : Save the Date !',
    excerpt: 'Un événement unique au Bénin célébrant la dignité et les compétences des personnels de maison. Au programme : célébrations culturelles, témoignages inspirants, espace recrutement et networking. Rejoignez-nous !',
    date: '20 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Événement',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    featured: false,
    content: `
        <p>L'ADCC est fière d'annoncer l'organisation du tout premier Festival des Personnels de Maison au Bénin ! Un événement inédit qui célèbrera la dignité, les compétences et la contribution essentielle de ces travailleurs souvent invisibles.</p>
        
        <h3>Pourquoi ce festival ?</h3>
        <p>Les personnels de maison – femmes de ménage, cuisiniers, nounous, gardiens, chauffeurs – sont indispensables au fonctionnement de nombreux foyers et entreprises. Pourtant, leur travail reste peu reconnu et valorisé. Ce festival veut changer le regard de la société.</p>
        
        <h3>Au programme</h3>
        <ul>
          <li><strong>Célébrations culturelles</strong> : Musique, danse et expressions artistiques mettant à l'honneur ces métiers.</li>
          <li><strong>Témoignages inspirants</strong> : Des parcours de vie, des réussites, des histoires qui donnent espoir.</li>
          <li><strong>Espace de rencontres professionnelles</strong> : Un lieu d'échange entre personnels formés et employeurs responsables.</li>
          <li><strong>Ateliers de networking et speed-meeting</strong> : Créez des connexions, trouvez des opportunités.</li>
          <li><strong>Présentation de profils qualifiés</strong> : Les bénéficiaires de nos formations pourront se présenter aux employeurs partenaires.</li>
        </ul>
        
        <h3>Un événement ouvert à tous</h3>
        <p>Que vous soyez personnel de maison, employeur, partenaire institutionnel ou simplement curieux, vous êtes les bienvenus ! Le festival est gratuit et ouvert au public.</p>
        
        <h3>Comment participer ?</h3>
        <p>Inscrivez-vous dès maintenant via notre page "Nos Actions". Vous pouvez participer en tant que visiteur, exposant, témoin ou recruteur.</p>
        
        <p><strong>Juin 2026 : Ensemble, célébrons la dignité du travail !</strong></p>
      `
  }];
  const featuredPost = posts.find(p => p.featured);
  const regularPosts = posts.filter(p => !p.featured);
  return <Layout data-id="element-779">
      <SEO {...pageSEO.blog} data-id="element-780" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-781">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-782">
          <h1 className="text-4xl font-bold mb-4" data-id="element-783">Actualités ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-784">
            Suivez nos avancées, découvrez nos événements et restez informés de
            notre action pour l'insertion professionnelle digne.
          </p>
        </div>
      </div>

      {/* Featured Article */}
      {featuredPost && <section className="py-12 bg-white" data-id="element-785">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-786">
            <div className="mb-8" data-id="element-787">
              <span className="inline-flex items-center gap-2 bg-[#1E88E5]/10 text-[#1E88E5] px-4 py-2 rounded-full text-sm font-semibold" data-id="element-788">
                <Users className="w-4 h-4" data-id="element-789" />
                Article à la une
              </span>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-790">
              <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-791">
                <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-[400px] object-cover" data-id="element-792" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold text-[#1E88E5] uppercase tracking-wide" data-id="element-793">
                  {featuredPost.category}
                </div>
              </div>

              <div className="lg:pl-8" data-id="element-794">
                <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4" data-id="element-795">
                  <div className="flex items-center" data-id="element-796">
                    <Calendar className="w-4 h-4 mr-2" data-id="element-797" />
                    {featuredPost.date}
                  </div>
                  <div className="flex items-center" data-id="element-798">
                    <User className="w-4 h-4 mr-2" data-id="element-799" />
                    {featuredPost.author}
                  </div>
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-800">
                  {featuredPost.title}
                </h2>

                <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-801">
                  {featuredPost.excerpt}
                </p>

                <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-lg mb-6" data-id="element-802">
                  <p className="text-gray-700 text-sm" data-id="element-803">
                    <strong data-id="element-804">Notre premier pas :</strong> Ce forum a posé les
                    bases de notre approche – écouter d'abord, agir ensuite.
                  </p>
                </div>

                <Link to="/impact" data-id="element-805">
                  <Button className="gap-2" data-id="element-806">
                    Découvrir notre vision d'impact
                    <ArrowRight className="w-4 h-4" data-id="element-807" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>}

      {/* Other Articles */}
      <section className="py-16 bg-gray-50" data-id="element-808">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-809">
          <div className="mb-10" data-id="element-810">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-811">
              Événements à venir
            </h2>
            <p className="text-gray-600 mt-2" data-id="element-812">
              Nos prochaines actions pour 2026
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-813">
            {regularPosts.map(post => <Card key={post.id} className="flex flex-col h-full overflow-hidden hover:shadow-lg transition-shadow duration-300 bg-white" data-id="element-814">
                <div className="h-56 overflow-hidden relative" data-id="element-815">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-816" />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#1E88E5] uppercase tracking-wide flex items-center gap-1" data-id="element-817">
                    {post.category === 'Formation' ? <GraduationCap className="w-3 h-3" data-id="element-818" /> : <PartyPopper className="w-3 h-3" data-id="element-819" />}
                    {post.category}
                  </div>
                  {post.id === 2 && <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide animate-pulse" data-id="element-820">
                      Inscriptions ouvertes
                    </div>}
                </div>
                <CardContent className="flex-grow p-6 flex flex-col" data-id="element-821">
                  <div className="flex items-center text-gray-400 text-sm mb-3 space-x-4" data-id="element-822">
                    <div className="flex items-center" data-id="element-823">
                      <Calendar className="w-4 h-4 mr-1" data-id="element-824" />
                      {post.date}
                    </div>
                    <div className="flex items-center" data-id="element-825">
                      <User className="w-4 h-4 mr-1" data-id="element-826" />
                      {post.author}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-827">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-6 line-clamp-3 flex-grow" data-id="element-828">
                    {post.excerpt}
                  </p>
                  <Link to="/actions" data-id="element-829">
                    <Button variant="secondary" className="w-full gap-2" data-id="element-830">
                      {post.id === 2 ? "S'inscrire aux ateliers" : 'Participer au festival'}
                      <ArrowRight className="w-4 h-4" data-id="element-831" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-white" data-id="element-832">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-833">
          <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] rounded-2xl p-8 md:p-12 text-white" data-id="element-834">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-835">
              Restez informés de nos actualités
            </h2>
            <p className="text-blue-100 mb-8" data-id="element-836">
              Suivez-nous sur les réseaux sociaux pour ne rien manquer de nos
              événements et de notre action.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-837">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#1E88E5] font-semibold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-838">
                Facebook
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 transition-colors border border-white/30" data-id="element-839">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}